import api from "./index";

// 分页查询检测员
export function fetchInspectors(params) {
    return api.post("/web/inspector/page", params);
}

// 创建检测员
export function createInspector(data) {
    return api.post("/web/inspector/add", data);
}

// 删除检测员
export function deleteInspector(inspectorId) {
    return api.delete(`/web/inspector/delete/${inspectorId}`);
}

// 修改检测员
export function updateInspector(data) {
    return api.put("/web/inspector/update", data);
}
